import { publicRequest } from "../../../requestMeth";

const authHeaders = (token) => ({ token: `Bearer ${token}` });

export const searchAgentRecommendations = async (
  token,
  params = {},
) => {
  const response = await publicRequest.get("/internal/recommendations/search", {
    headers: authHeaders(token),
    params,
  });

  return response.data;
};

export const getAgentRecommendationById = async (id, token) => {
  const response = await publicRequest.get(
    `/internal/recommendations/${id}`,
    {
      headers: authHeaders(token),
    },
  );

  return response.data;
};

export const updateAgentRecommendationStatus = async (
  id,
  status,
  reason,
  token,
) => {
  const response = await publicRequest.patch(
    `/internal/recommendations/${id}/status`,
    {
      status,
      reason: reason || null,
    },
    {
      headers: authHeaders(token),
    },
  );

  return response.data;
};

export const convertAgentRecommendationToProject = async (
  id,
  project,
  token,
) => {
  const response = await publicRequest.post(
    `/internal/recommendations/${id}/project`,
    project,
    {
      headers: authHeaders(token),
    },
  );

  return response.data;
};

export const getRecommendationCompanies = async (token) => {
  const response = await publicRequest.get("/master/companies", {
    headers: authHeaders(token),
    params: { type: "company" },
  });

  return response.data;
};

export const getRecommendationBranches = async (token) => {
  const response = await publicRequest.get("/master/companies", {
    headers: authHeaders(token),
    params: { type: "branch_offices" },
  });

  return response.data;
};
